import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import setPropertyVh from '../../utils/setPropertyVh';
import Instructor from '../../components/Instructor/Instructor';
import Xbutton from 'components/Xbutton';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import './Onboarding_Lesson_intro.scss';

const Onboarding_Lesson_intro = ({
    onBack,
    onContinue,
    onExit,
    exitButtonType = 'x',
    isFirstStep = true,
    lessonImgURL,
    teaserThumbnail,
    name,
    description,
    instructorName,
    AnimalType,
    teaserUrl,
    VolumeSwitchState,
    onIntroCompleted,
}) => {
    const { t } = useTranslation();
    setPropertyVh();

    const [showVideo, setShowVideo] = useState(false);
    const [introMarkedComplete, setIntroMarkedComplete] = useState(false);

    const markIntroComplete = () => {
        if (!introMarkedComplete) {
            setIntroMarkedComplete(true);
            onIntroCompleted && onIntroCompleted();
        }
    };

    const handleWatchIntro = () => {
        if (teaserUrl) {
            setShowVideo(true);
        } else {
            markIntroComplete();
            onContinue && onContinue();
        }
    };

    const handleVideoFinish = () => {
        setShowVideo(false);
        markIntroComplete();
        onContinue && onContinue();
    };

    const handleVideoExit = () => {
        setShowVideo(false);
    };

    return (
        <>
            {showVideo && (
                <div className="Onboarding_Lesson_intro__video-container">
                    <VideoPlayer
                        URL={t(teaserUrl)}
                        onExit={handleVideoExit}
                        onContinue={handleVideoFinish}
                        IsCurrentSelectedStepItemCompleted={true}
                        isSkippable={true}
                        volume={VolumeSwitchState}
                        VideoPlayerLoop={false}
                    />
                </div>
            )}
            <div className={"Onboarding-container"}>
                <div className={"Onboarding-header"}>
                    <div className={"Onboarding-header__side"}>
                        {exitButtonType === 'exit' && <ButtonCircle classes="ButtonCircle-exit ButtonCircle-50px" onClick={onExit} />}
                    </div>
                    <div className={"Onboarding-header__center"}>{t("onboarding.whatNeedForLesson")}</div>
                    <div className={"Onboarding-header__side Onboarding-header__side--end"}>
                        {exitButtonType === 'x' && <Xbutton sizeM onClose={onExit} />}
                        {exitButtonType === 'exit' && !isFirstStep && <ButtonCircle classes="ButtonCircle-back ButtonCircle-50px" onClick={onBack} />}
                    </div>
                </div>
                <div className={"Onboarding-content Onboarding-content-center Onboarding_Lesson_intro__container hideScrollbar"}>
                    <div className={"Onboarding-text-container"}>
                        <div className={"Onboarding-title"}>{t("onboarding.Onboarding_intro-title")}</div>
                    </div>
                    <div className={"Onboarding--card"} onClick={handleWatchIntro} style={{ cursor: 'pointer' }}>
                        <div className={"Onboarding_Lesson_intro__img-wrap"}>
                            <img className={"Onboarding--card__img Onboarding--card__img--border Onboarding_Lesson_intro__img"} src={"/" + lessonImgURL} alt={name} />
                            <div className={"Onboarding_Lesson_intro__play"}>
                                <img src="/assets/icons/icon_play-circle-white.svg" alt="play" />
                            </div>
                        </div>
                        <Instructor
                            AnimalType={AnimalType}
                            isInlineStart={true}
                        />
                    </div>
                    <div className={"Onboarding-subtitle"}>{name}</div>
                    <div className='Room'></div>
                </div>
                <div className={"Onboarding-footer"}>
                    <button onClick={onContinue} className={"button Onboarding-button buttonCatbears buttonCatbears_White"}>
                        {t("general.skip")}
                    </button>
                    <button onClick={handleWatchIntro} className={"button Onboarding-button arcadeBtn arcadeBtnLarge"}>
                        <img className="icon-play_triangle" src="/assets/icons/icon-play_triangle.svg" alt="" />
                        {t("onboarding.watchIntro")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default Onboarding_Lesson_intro;
